import { PublicClient } from 'viem';
import { TEAM_TOKEN_DISTRIBUTION_ABI } from '@/contracts/TeamTokenDistribution.abi';
import type { Address } from 'viem';

export async function getClaimableAmountForGrant(
  publicClient: PublicClient,
  contractAddress: Address,
  beneficiary: Address,
  grantId: bigint
): Promise<bigint> {
  try {
    const claimableAmount = await publicClient.readContract({
      address: contractAddress,
      abi: TEAM_TOKEN_DISTRIBUTION_ABI,
      functionName: 'releasableAmountForGrant',
      args: [beneficiary, grantId],
    }) as bigint;

    console.log(`Queried claimable amount for grant ${grantId}:`, claimableAmount.toString());
    return claimableAmount;
  } catch (err) {
    console.error('Error fetching claimable amount for grant:', err);
    return BigInt(0);
  }
}
